import * as React from "react";
import { Badge, BadgeContainer } from "@progress/kendo-react-indicators";
import { WorkQueueColors } from "../../../../utilities/enums/WorkQueueColors";

import {
  TaskBoardColumn,
  TaskBoardColumnProps,
  TaskBoardColumnHeaderProps,
} from "@progress/kendo-react-taskboard";

const themeColor: any = {
  new: WorkQueueColors.Blue,
  publicHearingPending: WorkQueueColors.BlueGreen,
  agPending: WorkQueueColors.Green,
  gproPending: WorkQueueColors.Yellow,
  sosPending: WorkQueueColors.Orange,
  readyForPromulgation: WorkQueueColors.Red,
};

const ColumnHeader = (props: TaskBoardColumnHeaderProps) => {
  const { title, status } = props.column;
  return (
    <div className={"task-board-column-header"}>
      <div className={"k-taskboard-column-header-text k-text-ellipsis"}>
        <>
          <BadgeContainer style={{ left: "12px", top: "-4px" }}>
            <Badge style={{ backgroundColor: themeColor[status], color: "black", border: "0px", zIndex: 0 }}>
              {props.tasks && props.tasks.length}
            </Badge>
          </BadgeContainer>
          <span style={{ marginLeft: "30px" }}>{title}</span>
        </>
      </div>
      <span className={"k-spacer"} />
    </div>
  );
};

export const Column = (props: TaskBoardColumnProps) => {
  return <TaskBoardColumn {...props} header={ColumnHeader} onColumnEnterEdit={() => { }} />;
};